"use strict";

// When page ready
jQuery(pageReady);

function pageReady($) {
  // Get baseurl and page language
  var baseUrl = $('base').attr('href');
  var $html = $('html');
  var langue = $html.attr('lang');
  var $body = $html.find('body');
  var $window = $(window);
} // When page loaded


jQuery(window).load(onLoad);

function onLoad() {
  var $ = jQuery; // HP map

  var $hpMap = $('#hp-gmap-canvas');

  if ($hpMap.length) {
    var initMap = function initMap() {
      var parc = new google.maps.LatLng(45.745754, 4.907927);
      infowindow = new google.maps.InfoWindow();
      map = new google.maps.Map($hpMap[0], {
        center: parc,
        zoom: 15,
        disableDefaultUI: true,
        zoomControl: true
      });
      var request = {
        query: 'Parc de la Marne, Rue de la Marne, Bron',
        fields: ['name', 'geometry']
      };
      service = new google.maps.places.PlacesService(map);
      service.findPlaceFromQuery(request, function (results, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          for (var i = 0; i < results.length; i++) {
            createMarker(results[i]);
          }

          map.setCenter(results[0].geometry.location);
        }
      });
    };

    var createMarker = function createMarker(place) {
      var marker = new google.maps.Marker({
        map: map,
        position: place.geometry.location
      });
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.setContent(place.name);
        infowindow.open(map, this);
      });
    };

    var map;
    var service;
    var infowindow;
    initMap();
  } // Clairiere map


  var $interactiveMap = $('.map-left');

  if ($interactiveMap.length) {
    $interactiveMap.on('mouseenter', '#marqueur > g', function () {
      var currentArea = $(this).attr('id').replace('_pin', '');
      $interactiveMap.find('#zone_active > #' + currentArea + '_on').addClass('visible');
    });
    $interactiveMap.on('mouseleave', '#marqueur > g', function () {
      var currentArea = $(this).attr('id').replace('_pin', '');
      $interactiveMap.find('#zone_active > #' + currentArea + '_on').removeClass('visible');
    });
    $interactiveMap.on('click', '#marqueur > g', function () {
      var currentArea = $(this).attr('id').replace('_pin', '');
      console.log(currentArea);
      $interactiveMap.find('#zone_active > g').removeClass('selected');
      $interactiveMap.find('#zone_active > #' + currentArea + '_on').addClass('selected');
      var $interactiveMapContent = $('.map-right');
      var $currentItem = $interactiveMapContent.find('.map-item[data-slug="' + currentArea + '"]');
      $interactiveMapContent.find('.map-item,.map-wrapper-text').hide();
      $currentItem.fadeIn();

      if ($currentItem.length && $(window).width() < 980) {
        $([document.documentElement, document.body]).animate({
          scrollTop: $currentItem.offset().top - 150
        }, 1000);
      }
    });
  } // HP news link change


  var $catLinks = $('.news-bloc article .post-meta > a');

  if ($catLinks.length) {
    $catLinks.click(function (e) {
      e.preventDefault();
      window.location.href = $(this).parent().parent().find('.entry-title > a').attr('href');
    });
  }
}
//# sourceMappingURL=clairiere-ra.js.map
